import { useDispatch, useSelector } from "react-redux";

import { useEffect, useRef } from "react";
import { SITE_ID_FETCH_SUCCESS } from "../../../Reducer/SiteIdSlice";
import { Link, useParams } from "react-router-dom";
import * as echarts from "echarts";
import { useState } from "react";
import ReactEcharts from "echarts-for-react";
import Agent from "../../../Network/Agent";
import { cancelAllRequests, createController } from "../../../Network/API";
import { set } from "nprogress";
import isTenantUser from "../../../CustomHook/tenantUser";

export default function DcEnergyMeter() {
    const today = new Date().toISOString().slice(0, 10);
    const siteDashboardData = useSelector(state => state.siteDashboardReducer);
    // console.log(siteDashboardData)
    const [rms, setRms] = useState()
    const [tenants, setAllTenant] = useState([])
    const [dc_kw_avg_hourly, setDcAvgHourly] = useState()
    const [data, setData] = useState({ times: [], site_down: [], site_avail: [] })
    const [tenant_id, setTenant] = useState('')
    const echarts_react_2 = useRef();
    const echarts_react = useRef();
    const ddd = useParams();
    const dispatch = useDispatch()
    const { user: profileUser } = useSelector(state => state.profileReducer);
    const { user: authUser } = useSelector(state => state.authReducer);
    const tenantUser = isTenantUser(profileUser?.id ? profileUser : authUser);
    const [loading, setLoading] = useState(true);
    const [dcFilterType, setDcFilterType] = useState('last24hour');
    const [availabilityFilterType, setAvailabilityFilterType] = useState('CurrentMonth');
    const [dcVoltageFilterType, setDcVoltageFilterType] = useState('last24hour');
    const [dcDateValue, setDcDateValue] = useState({ from: today, to: today });
    const [availabilityDateValue, setAvailabilityDateValue] = useState({ from: today, to: today });
    const [dcVoltageDateValue, setDcVoltageDateValue] = useState({ from: today, to: today });
    const [showModal, setShowModal] = useState(false);
    const [showSetting, setShowSetting] = useState(false);
    const [settingLoading, setSettingLoading] = useState(false);
    const [settingSaving, setSettingSaving] = useState(false);
    const [dcSetting, setDcSetting] = useState({
        rms_id: '',
        temp: '',
        battery_high: '',
        battery_low: '',
        ct_value: '',
        max_load_current: '',
        can_save: false,
    });
    const [activeModalType, setActiveModalType] = useState('dc');
    const [tempDate2, setTempDate2] = useState(today);
    const [tempDate, setTempDate] = useState(today);
    const [step, setStep] = useState(1);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const [chartData, setChartData] = useState(null)
    const dcControllerRef = useRef(null);
    const availabilityControllerRef = useRef(null);
    const voltageControllerRef = useRef(null);


    // console.log(siteDashboardData?.tenants?.[ddd.id]);

    useEffect(() => {
        if (!ddd?.id) return;

        Agent.SITE_DASHBOARD.site_id_fetch(ddd.id)
            .then((result) => {
                if (result) {
                   // console.log(result)
                    setAllTenant(result?.data || []);
                    setTenant(result?.data?.[0]?.tenant_id); // async, triggers re-render
                    //dispatch(SITE_ID_FETCH_SUCCESS(ddd.id));
                } else {
                    setAllTenant([]);
                    //console.error("No result received for site_id_fetch");
                }
            })
            .catch((err) => {
                console.error("Error fetching site ID:", err);
            });

        // const saved = localStorage.getItem(`tenants_${ddd.id}`);
        // if (saved) {
        //     try {
        //         const parsed = JSON.parse(saved);
        //         setAllTenant(parsed.tenants || []);
        //         setTenant(parsed.tenants[0]?.tenant_id); // async, triggers re-render
        //     } catch (err) {
        //         console.error(`Error parsing localStorage for tenants_${ddd.id}:`, err);
        //     }
        // } else {
        //     setAllTenant(null);
        // }
    }, [ddd?.id]);

    useEffect(() => {
        if (ddd?.id && tenant_id) {
            fetchData();
        }
    }, [ddd?.id, tenant_id, dcDateValue, dcFilterType]);

    useEffect(() => {
        if (ddd?.id && tenant_id) {
            fetchAvailabilityTrend();
        }
    }, [ddd?.id, tenant_id, availabilityDateValue, availabilityFilterType]);

    useEffect(() => {
        if (ddd?.id && tenant_id) {
            dc_voltage_load();
        }
    }, [ddd?.id, tenant_id, dcVoltageDateValue, dcVoltageFilterType]);


    const fetchData = async () => {
        if (dcControllerRef.current) {
            dcControllerRef.current.abort();
        }

        const controller = new AbortController();
        dcControllerRef.current = controller;

        const signal = controller.signal;

        dispatch(SITE_ID_FETCH_SUCCESS(ddd.id));
        setRms(siteDashboardData?.data?.[ddd.id]);

        const array_data = {
            site_id: ddd.id,
            tenant_id: tenant_id,
            date: dcFilterType === 'last24hour' ? today : dcDateValue.from,
            to_date: dcFilterType === 'last24hour' ? today : dcDateValue.to
        };

        await delay(200); // optional

        try {
            Agent.SITE_DASHBOARD.dc_avg_kw_hourly(array_data, signal)
                .then((result) => {
                    if (result) {
                        // setLoading(false)

                        // console.log(result)
                        setDcAvgHourly(result);
                    } else {
                        // setLoading(false)
                        console.error("No result received");
                    }
                })
                .catch((err) => {
                    if (err.name === 'AbortError') {
                        console.log('Request was aborted');
                    } else {
                        console.error(err);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
            // Do something with result
        } catch (err) {
            setLoading(false)
            // console.error(err);
        }
    }

    const fetchAvailabilityTrend = async () => {
        if (availabilityControllerRef.current) {
            availabilityControllerRef.current.abort();
        }

        const controller = new AbortController();
        availabilityControllerRef.current = controller;

        const signal = controller.signal;
        const array_data = {
            site_id: ddd.id,
            tenant_id: tenant_id,
            date: availabilityFilterType === 'CurrentMonth' ? today : availabilityDateValue.from,
            to_date: availabilityFilterType === 'CurrentMonth' ? today : availabilityDateValue.to
        };
        try {
            const result = await Agent.SITE_DASHBOARD.dc_availability(array_data, signal);
            if (result) {
                setLoading(false)

                // console.log(result)
                setData(result);

            } else {
                // setLoading(false)
                console.error("No result received");
            }
        } catch (err) {
            setLoading(false)
            // console.error(err);
        }
    }


    const dc_voltage_load = () => {

        if (voltageControllerRef.current) {
            voltageControllerRef.current.abort();
        }

        const controller = new AbortController();
        voltageControllerRef.current = controller;

        const signal = controller.signal;

        Agent.SITE_DASHBOARD.dc_voltage({
            site_id: ddd.id,
            tenant_id: tenant_id,
            date: dcVoltageFilterType === 'last24hour' ? today : dcVoltageDateValue.from,
            to_date: dcVoltageFilterType === 'last24hour' ? today : dcVoltageDateValue.to
        }, signal)
        .then((result) => {
            
            if (result) {
                setChartData(result?.data);
            } 

            if (result?.response?.data?.success==false) {
                alert(result.response.data.message);
            }
        })
        .catch((err) => {

         //  console.error(err);
            if (err.name === 'AbortError') {
                console.log('Request was aborted');
            } else {
               // console.error(err);
            }
        });
    }

    // Sync temp dates based on active modal target
    useEffect(() => {
        if (showModal) {
            const selectedDate = activeModalType === 'availability' ? availabilityDateValue : (activeModalType === 'voltage' ? dcVoltageDateValue : dcDateValue);
            setTempDate(selectedDate.from);
            setTempDate2(selectedDate.to);
        }
    }, [showModal, activeModalType, dcDateValue, availabilityDateValue, dcVoltageDateValue]);

    const getDateOptionLabel = (range) => {
        if (!range?.from || !range?.to) {
            return 'Date';
        }
        if (range.from === range.to) {
            return `Date (${range.from})`;
        }
        return `Date (${range.from} to ${range.to})`;
    };

    const openDateModal = (type) => {
        setActiveModalType(type);
        setShowModal(true);
    };





    const option = {
        color: ['#008000', '#FFC300'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        legend: {
            data: ['Dc Power', 'Max.Threshold']
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: false,
                data: dc_kw_avg_hourly?.times,
                axisLabel: {
                    formatter: function (value, index) {
                        // Split the value by spaces to get time and date parts
                        var parts = value.split(' ');
                        var time = parts[0] + ' ' + parts[1]; // e.g., "00:00 AM"
                        var date = parts[2] + ' ' + parts[3]; // e.g., "01 Jul, 24"

                        // Only show the time label at intervals (e.g., every 12 hours)
                        if (index % 24 === 0) {
                            // return time + '\n' + date;
                            return date;
                        }
                        return '';
                    },
                    fontSize: 10,
                    rotate: 0,
                    interval: 0,
                    align: 'left'
                }
            }
        ],
        yAxis: [
            {
                name: 'Dc Power',
                nameLocation: 'middle',
                nameGap: 60,
                nameTextStyle: {
                    fontWeight: 'bold',
                    color: '#000000'
                },
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#ddd'
                    }
                },
                axisLabel: {
                    formatter: '{value} kW'
                },
                axisPointer: {
                    snap: true
                }
            }
        ],
        series: [
            {
                name: 'Dc Power',
                type: 'line',
                symbol: 'none',
                sampling: 'lttb',
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(51, 176, 16,0.8)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(10, 247, 73,0.3)'
                        }
                    ])
                },
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: 'rgba(51, 176, 16,1)'
                },
                data: dc_kw_avg_hourly?.avg_data,
            },
            {
                name: 'Max.Threshold',
                type: 'line',
                symbol: 'none',
                sampling: 'lttb',
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(250, 218, 57,0.8)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(58,77,233,0.3)'
                        }
                    ])
                },
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: 'rgba(250, 218, 57,1)'
                },
                data: dc_kw_avg_hourly?.max_data
            }
        ]
    };


    useEffect(() => {
        const chartInstance = echarts_react_2.current?.getEchartsInstance();
        if (chartInstance) {
            if (loading) {
                chartInstance.showLoading();
            } else {
                chartInstance.hideLoading();
            }
        }
    }, [loading]);

    const optionAvail = {
        color: ['#F6A6A6', '#9EDFB3', '#A8C8F5'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            backgroundColor: 'rgba(255, 255, 255, 0.96)',
            borderColor: '#e8ecf5',
            borderWidth: 1,
            textStyle: {
                color: '#3f4860'
            },
            formatter: function (params) {
                const title = params?.[0]?.axisValueLabel || '';
                const rows = params.map((item) => `${item.marker} ${item.seriesName}: ${item.value ?? 0}%`).join('<br/>');
                return `${title}<br/>${rows}`;
            }
        },
        legend: {
            top: 0,
            icon: 'roundRect',
            itemWidth: 12,
            itemHeight: 8,
            textStyle: {
                fontSize: 12,
                color: '#5c6480'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            top: '16%',
            bottom: '8%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: data.times,
                axisTick: {
                    alignWithLabel: true
                },
                axisLine: {
                    lineStyle: {
                        color: '#e5e9f2'
                    }
                },
                axisLabel: {
                    color: '#5c5f7a',
                    fontSize: 11,
                    interval: 'auto',
                    formatter: function (value) {
                        return value && value.length > 10 ? `${value.slice(0, 10)}...` : value;
                    }
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                min: 0,
                max: 100,
                axisLabel: {
                    formatter: '{value} %',
                    color: '#5c5f7a'
                },
                splitLine: {
                    lineStyle: {
                        color: '#eff3fa',
                        type: 'dashed'
                    }
                },
                axisPointer: {
                    snap: true
                }
            }
        ],
        series: [
            {
                name: 'Site Down',
                type: 'bar',
                barWidth: 16,
                barGap: '30%',
                emphasis: {
                    focus: 'series'
                },
                label: {
                    show: false,
                    position: 'top',
                    formatter: (params) => `${params.value ?? 0}%`,
                    color: '#8a3650',
                    fontSize: 10
                },
                data: data.site_down,
                itemStyle: {
                    borderRadius: [6, 6, 0, 0],
                    borderColor: '#f7d2d2',
                    borderWidth: 1
                }
            },
            {
                name: 'Site Availability',
                type: 'bar',
                barWidth: 16,
                emphasis: {
                    focus: 'series'
                },
                label: {
                    show: false,
                    position: 'top',
                    formatter: (params) => `${params.value ?? 0}%`,
                    color: '#2f6b45',
                    fontSize: 10
                },
                data: data.site_avail,
                itemStyle: {
                    borderRadius: [6, 6, 0, 0],
                    borderColor: '#d6efd9',
                    borderWidth: 1
                }
            },
            {
                name: 'Grid Availability',
                type: 'line',
                barWidth: 16,
                emphasis: {
                    focus: 'series'
                },
                label: {
                    show: true,
                    position: 'top',
                    formatter: (params) => `${params.value ?? 0}%`,
                    color: '#345d93',
                    fontSize: 10
                },
                data: data.ac_avail,
                itemStyle: {
                    borderRadius: [6, 6, 0, 0],
                    borderColor: '#d8e6fa',
                    borderWidth: 1
                }
            }
        ]
    };


     const buildOption = (type, unit) => {
            if (!chartData) return {}
    
            const colors = ['#008000', '#FFC300', '#1f77b4']
            const series = []
            const legendData = []
    
            Object.keys(chartData.tenants).forEach((tenantId, index) => {
                const tenant = chartData.tenants[tenantId]
                const color = colors[index % colors.length]
    
                legendData.push(tenant.name)
    
                // 🔹 MAIN LINE (legend color comes from here)
                series.push({
                    name: tenant.name,
                    type: 'line',
                    symbol: 'none',
                    sampling: 'lttb',
                    lineStyle: { color },
                    itemStyle: { color },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color },
                            { offset: 1, color: 'rgba(255,255,255,0.15)' }
                        ])
                    },
                    data: tenant[type]
                })
    
                // 🔹 MAX POINT (❌ legend এ যাবে না)
                const max = Math.max(...tenant[type])
                const maxIndex = tenant[type].indexOf(max)
    
                if (maxIndex !== -1) {
                    series.push({
                        name: `${tenant.name}-max`,
                        type: 'scatter',
                        showInLegend: false,   // ✅ KEY LINE
                        symbolSize: 12,
                        z: 10,
                        itemStyle: { color },
                        label: {
                            show: true,
                            formatter: `Max: ${max} ${unit}\n${chartData.times[maxIndex]}`,
                            position: 'top',
                            fontSize: 10,
                            backgroundColor: '#fff',
                            padding: [4, 6],
                            borderRadius: 4
                        },
                        data: [[chartData.times[maxIndex], max]]
                    })
                }
            })
    
            return {
                color: colors,   // ✅ IMPORTANT
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    top: 10,
                    data: legendData   // ✅ only tenant names
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: chartData.times
                },
                yAxis: {
                    type: 'value',
                    axisLabel: { formatter: `{value} ${unit}` }
                },
                series
        }
    }

    const openDcSetting = async () => {
        if (!ddd?.id || !tenant_id) return;
        setShowSetting(true);
        setSettingLoading(true);
        const result = await Agent.SITE_DASHBOARD.dc_tenant_setting(ddd.id, tenant_id);
        const setting = result?.data;
        if (setting) {
            setDcSetting({
                rms_id: setting.rms_id ?? '',
                temp: setting.temp ?? '',
                battery_high: setting.battery_high ?? '',
                battery_low: setting.battery_low ?? '',
                ct_value: setting.ct_value ?? '',
                max_load_current: setting.max_load_current ?? '',
                can_save: !!setting.can_save,
            });
        } else {
            alert(result?.message || 'Could not load RMS configuration');
        }
        setSettingLoading(false);
    }

    const saveDcSetting = async () => {
        setSettingSaving(true);
        const result = await Agent.SITE_DASHBOARD.save_dc_tenant_setting({
            site_id: ddd.id,
            tenant_id: tenant_id,
            rms_id: dcSetting.rms_id,
            temp: dcSetting.temp,
            battery_high: dcSetting.battery_high,
            battery_low: dcSetting.battery_low,
            ct_value: dcSetting.ct_value,
            max_load_current: dcSetting.max_load_current,
        });
        setSettingSaving(false);
        alert(result?.message || 'Could not save RMS configuration');
        if (result?.success) {
            setShowSetting(false);
        }
    }

    const settingField = (label, key) => (
        <div className="row align-items-center mb-3">
            <label className="col-4 col-form-label">{label}</label>
            <div className="col-8">
                <div className="d-flex align-items-center gap-1">
                    <input className="form-control text-center" readOnly value="00" />
                    <span>:</span>
                    <input className="form-control text-center" readOnly value="00" />
                    <span>:</span>
                    <input
                        className="form-control text-center"
                        value={dcSetting[key]}
                        onChange={(e) => setDcSetting((prev) => ({ ...prev, [key]: e.target.value }))}
                    />
                </div>
            </div>
        </div>
    );

    return (
        <>
            <div className="row ms-1 me-1">
                <div className="col-md-12">
                    <div className="float-end mt-2">
                        <div>
                            {!tenantUser && (
                            <div className="d-flex align-items-center gap-1">
                            <select
                                className="form-select form-select-sm"
                                value={tenant_id}
                                onChange={(e) => setTenant(e.target.value)}
                            >
                                {tenants?.length > 0 && tenants?.map((tenant, index) => (
                                    <option key={index} value={tenant.tenant_id}>{tenant.tenant_name}</option>
                                ))}
                            </select>
                            <button type="button" className="btn btn-sm btn-outline-secondary" title="RMS Configuration" onClick={openDcSetting}>
                                <i className="fa-solid fa-gear"></i>
                            </button>
                            </div>
                            )}
                        </div>
                    </div></div>
            </div>
            <div className="row ms-1 me-1">

                <div className="col-md-6">
                    <div className="card shadow-sm border-0 bg-cc mt-2" style={{ minHeight: '350px' }}>
                        <div className="card-header  border-bottom card-title bg-white align-items-center d-flex">

                            <b className="main-card-title mb-0 flex-grow-1">DC Power- {tenant_id == 1 ? 'Banglalink' : (tenant_id == 3 ? 'Robi' : (tenant_id == 4 ? 'GP' : 'Unknown'))}</b>
                            <div className="flex-shrink-0">
                                <div className="app-search">
                                    <div className="input-group">

                                        <select
                                            className="form-select form-select-sm"
                                            value={dcFilterType}
                                            onClick={() => {
                                                if (dcFilterType === 'date') {
                                                    openDateModal('dc');
                                                }
                                            }}
                                            onChange={(e) => {
                                                setDcFilterType(e.target.value);
                                                if (e.target.value === 'date') {
                                                    openDateModal('dc');
                                                }
                                            }}
                                        >
                                            <option value="last24hour">Last 24Hr</option>
                                            <option value="date">{getDateOptionLabel(dcDateValue)}</option>
                                        </select>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-body bg-white">
                            <ReactEcharts ref={echarts_react_2} style={{ height: "300px" }} option={option} />

                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="col-12 text-center">
                        
                        <div className="card shadow-sm border-0 bg-cc mt-2" style={{ minHeight: '350px' }}>
                            <div className="card-header  border-bottom card-title bg-white align-items-center d-flex">
                                <div className="mb-0 flex-grow-1">
                                    <div className="btn-group btn-group-md ">
                                    <button type="button" className={`btn btn-outline-info   ${step == 1 ? 'btn-info' : 'bg-white'}`} onClick={() => setStep(1)}>Voltage</button>
                                    <button type="button" className={`btn btn-outline-info   ${step == 2 ? 'btn-info ' : 'bg-white'}`} onClick={() => setStep(2)}>Current</button>
                                    <button type="button" className={`btn btn-outline-info   ${step == 3 ? 'btn-info ' : 'bg-white'}`} onClick={() => setStep(3)}>Load(kW)</button>
                                </div>
                                </div>
                                <div className="flex-shrink-0">
                                    <div className="app-search">
                                        <div className="input-group">

                                            <select
                                                className="form-select form-select-sm"
                                            value={dcVoltageFilterType}
                                            onClick={() => {
                                                if (dcVoltageFilterType === 'date') {
                                                    openDateModal('voltage');
                                                }
                                            }}
                                            onChange={(e) => {
                                                setDcVoltageFilterType(e.target.value);
                                                if (e.target.value === 'date') {
                                                    openDateModal('voltage');
                                                }
                                            }}
                                            >
                                                <option value="last24hour">Last 24Hr</option>
                                                <option value="date">{getDateOptionLabel(dcVoltageDateValue)}</option>
                                            </select>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body bg-white">
 {step === 1 && (
                                <ReactEcharts option={buildOption('voltage', 'V')} style={{ height: 300 }} />
                            )}

                            {step === 2 && (
                                <ReactEcharts option={buildOption('current', 'A')} style={{ height: 300 }} />
                            )}

                            {step === 3 && (
                                <ReactEcharts option={buildOption('load', 'kW')} style={{ height: 300 }} />
                            )}
                            </div>
                        </div>

                    </div>

                </div>

                <div className="col-md-12">
                    <div className="card shadow-sm border-0 bg-cc mt-2" style={{ minHeight: '350px' }}>
                        <div className="card-header  border-bottom card-title bg-white align-items-center d-flex">

                            <b className="main-card-title mb-0 flex-grow-1">Availability- {tenant_id == 1 ? 'Banglalink' : (tenant_id == 3 ? 'Robi' : (tenant_id == 4 ? 'GP' : 'Unknown'))}</b>
                            <div className="flex-shrink-0">
                                <div className="app-search">
                                    <div className="input-group">

                                        <select
                                            className="form-select form-select-sm"
                                            value={availabilityFilterType}
                                            onClick={() => {
                                                if (availabilityFilterType === 'date') {
                                                    openDateModal('availability');
                                                }
                                            }}
                                            onChange={(e) => {
                                                setAvailabilityFilterType(e.target.value);
                                                if (e.target.value === 'date') {
                                                    openDateModal('availability');
                                                }
                                            }}
                                        >
                                            <option value="CurrentMonth">Current Month</option>
                                            <option value="date">{getDateOptionLabel(availabilityDateValue)}</option>
                                        </select>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-white">
                            <ReactEcharts ref={echarts_react} style={{ height: "300px" }} option={optionAvail} />
                        </div>
                    </div>
                </div>


            </div>




            {/* Date Filter Modal */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Date</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false);
                                        setActiveModalType('dc');
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={tempDate}
                                        onChange={(e) => setTempDate(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">To Date</label>
                                    <input type="date" className="form-control"
                                        value={tempDate2}
                                        onChange={(e) => setTempDate2(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                        setActiveModalType('dc');
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => {
                                        if (activeModalType === 'availability') {
                                            setAvailabilityDateValue({ from: tempDate, to: tempDate2 });
                                        }
                                        else if (activeModalType === 'voltage') {
                                            setDcVoltageDateValue({ from: tempDate, to: tempDate2 });
                                        } 
                                        
                                        else {
                                            setDcDateValue({ from: tempDate, to: tempDate2 });
                                        }
                                        setShowModal(false);
                                        setActiveModalType('dc');
                                    }}
                                >
                                    <i className="fa-solid fa-filter me-1"></i>
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSetting && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">RMS Configuration</h5>
                                <button type="button" className="btn-close" onClick={() => setShowSetting(false)}></button>
                            </div>
                            <div className="modal-body">
                                {settingLoading ? <p className="mb-0">Loading...</p> : (
                                    <>
                                        {settingField('Temperature', 'temp')}
                                        {settingField('DC Low (V)', 'battery_low')}
                                        {settingField('Site Down(A)', 'ct_value')}
                                        {settingField('Sanctioned Power (KW)', 'max_load_current')}
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowSetting(false)}>Close</button>
                                {dcSetting.can_save && (
                                    <button type="button" className="btn btn-success" disabled={settingLoading || settingSaving} onClick={saveDcSetting}>
                                        {settingSaving ? 'Saving...' : 'Save'}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
} 